import React, {Component} from 'react';

const dataSurvey = [
    {
        'img': 'fb-1.png',
        'right': 'like'
    },
    {
        'img': 'fb-2.png',
        'right': 'heart'
    },
    {
        'img': 'fb-3.png',
        'right': 'heart'
    },
    {
        'img': 'fb-4.png',
        'right': 'like'
    },
    {
        'img': 'fb-5.png',
        'right': 'heart'
    },
    {
        'img': 'fb-6.png',
        'right': 'like'
    },
    {
        'img': 'fb-7.png',
        'right': 'heart'
    },
    {
        'img': 'fb-8.png',
        'right': 'like'
    },
    {
        'img': 'fb-9.png',
        'right': 'heart'
    },
    {
        'img': 'fb-10.png',
        'right': 'like'
    }
];

class Survey extends Component {
    constructor(props) {
        super(props);
        this.state = {
            total: 10,
            right: 0,
            actualIndex: 0,
            status: '',

            done: false,
            wait: false
        }

    }

    handeClickButton(button) {
        if (!this.state.wait) {
            this.setStatus(button);
        }
    }

    setStatus(button) {
        let index = this.state.actualIndex;
        if (dataSurvey[this.state.actualIndex].right == button) {
            index++;
            this.setState({
                right: this.state.right + 1,
                status: 'right',
                wait: true,
            })
        } else {
            index++;
            this.setState({
                status: 'wrong',
                wait: true,
            })
        }
        setTimeout(() => {
            this.setActualIndex(index);
        }, 1000)
    }

    setActualIndex(index) {
        if (index < this.state.total) {
            this.setState({
                actualIndex: index,
                status: '',
                wait: false,
            })
        } else {
            const data = new FormData();
            data.append('survey', this.state.right);

            fetch('/ajax/survey.php', {
                'method': 'POST',
                body: data
            }).then(result => {
                return result.json();
            });

            this.setState({
                done: true,
                wait: false,
            })
        }
    }

    handleShare(event) {

        const data = new FormData();
        data.append('share', 1);

        fetch('/ajax/survey.php', {
            'method': 'POST',
            body: data
        }).then(result => {
            return result.json();
        });

        var width = 575,
            height = 400,
            left = ($(window).width() - width) / 2,
            top = ($(window).height() - height) / 2,
            url = event.currentTarget.href,
            opts = "status=1" + ",width=" + width + ",height=" + height + ",top=" + top + ",left=" + left;
        window.open(url, "twitter", opts);
        event.preventDefault();
    }

    render() {
        let {status, actualIndex, done, right, total, button} = this.state;

        return (
            <div className="container">
                <h3>Anketa</h3>
                <div className="img-box">
                    {(!done &&
                        <img src={"/images/survey/" + dataSurvey[actualIndex].img} alt="" />
                    )}
                    <div className={"status" + (done ? ' done-status' : '')}>
                        {(!done &&
                            <div className={"right" + (status == 'right' ? ' show' : '')}>
                                Správne!
                            </div>
                        )}
                        {(!done &&
                            < div className={"wrong" + (status == 'wrong' ? ' show' : '')}>
                                Nesprávne!
                            </div>
                        )}
                        <div className={"done" + (done ? ' show' : '') + (right < 6 ? ' pink' : ' green')}>
                            <img src={"/images/survey-result/" + right + ".jpg"} alt="" />
                            <a title="Zdieľať" className="share-button"
                               href={"https://www.facebook.com/sharer.php?u=https%3A%2F%2Fwww.trendis.sk%2Fsk%2Fblog%2Fprieskum-znaciek%3Fshare-survey%3Dtrue%26right%3D" + right}
                               onClick={(event) => this.handleShare(event)}><img src="/images/facebook-icon.png"
                                                                                 alt="" /></a>
                        </div>
                    </div>
                </div>
                {(!done &&
                    <div className="buttons">
                        <button id="like" onClick={() => this.handeClickButton('like')}>
                        </button>
                        <button id="heart" onClick={() => this.handeClickButton('heart')}>
                        </button>
                    </div>
                )}
            </div>
        );
    }
}

export default Survey;